function isPlainObject(v: unknown): v is Record<string, unknown> {
  return v !== null && typeof v === 'object' && !Array.isArray(v);
}

export function normalizeBookingListRecords(data: unknown): Record<string, unknown>[] {
  if (Array.isArray(data)) {
    return data.filter(isPlainObject);
  }
  if (isPlainObject(data)) {
    const inner = data.bookings ?? data.data ?? data.items ?? data.results;
    if (Array.isArray(inner)) {
      return inner.filter(isPlainObject);
    }
  }
  return [];
}
